export const FETCH_ANALYTICS_REPORT_STARTED = 'FETCH_ANALYTICS_REPORT_STARTED';
export const FETCH_ANALYTICS_REPORT_SUCCEEDED =
  'FETCH_ANALYTICS_REPORT_SUCCEEDED';
export const FETCH_ANALYTICS_REPORT_FAILED = 'FETCH_ANALYTICS_REPORT_FAILED';
export const START_DATE_CHANGED = 'START_DATE_CHANGED';
export const END_DATE_CHANGED = 'END_DATE_CHANGED';
export const SEARCH_ORGANIZATION_STARTED = 'SEARCH_ORGANIZATION_STARTED';
export const SEARCH_ORGANIZATION_SUCCEEDED = 'SEARCH_ORGANIZATION_SUCCEEDED';
export const SEARCH_ORGANIZATION_FAILED = 'SEARCH_ORGANIZATION_FAILED';
export const CLEAR_SUGGESTED_ORGANIZATIONS = 'CLEAR_SUGGESTED_ORGANIZATIONS ';
export const SELECT_ORGANIZATION = 'SELECT_ORGANIZATION';
export const REPORT_NOT_FOUND = 'REPORT_NOT_FOUND';
export const EXPORT_TO_EXCEL_STARTED = 'EXPORT_TO_EXCEL_STARTED';
export const EXPORT_TO_EXCEL_SUCCEEDED = 'EXPORT_TO_EXCEL_SUCCEEDED';
export const EXPORT_TO_EXCEL_FAILED = 'EXPORT_TO_EXCEL_FAILED';
